import gql from 'graphql-tag';

import dokkioLabelFragment from '../fragments/dokkioLabelFragment';

export const mutationCreateDokkioLabel = gql`
  mutation createDokkioLabel (
    $name: String!
    $description: String
    $icon: DokkioLabelIcon
    $color: DokkioLabelColor
    $dokkioTagType: DokkioLabelDokkioTagType
    $isMultiValue: Boolean
    $isBadgeDisplayed: Boolean
    $isNavDisplayed: Boolean
    $isPluralTagNames: Boolean
    $defaultAutoApplyConfidenceThreshold: Float
    $autoCreateDokkioTagConfidenceThreshold: Float
    $rowCreateMethod: RowCreateMethod!
    $filterNotableOrganizationSuggestions: Boolean
    $filterNotablePersonSuggestions: Boolean
    $filterDokkioUserNameSuggestions: Boolean
  ) {
    createDokkioLabel (
      name: $name
      description: $description
      icon: $icon
      color: $color
      dokkioTagType: $dokkioTagType
      isMultiValue: $isMultiValue
      isBadgeDisplayed: $isBadgeDisplayed
      isNavDisplayed: $isNavDisplayed
      isPluralTagNames: $isPluralTagNames
      defaultAutoApplyConfidenceThreshold: $defaultAutoApplyConfidenceThreshold
      autoCreateDokkioTagConfidenceThreshold: $autoCreateDokkioTagConfidenceThreshold
      rowCreateMethod: $rowCreateMethod
      filterNotableOrganizationSuggestions: $filterNotableOrganizationSuggestions
      filterNotablePersonSuggestions: $filterNotablePersonSuggestions
      filterDokkioUserNameSuggestions: $filterDokkioUserNameSuggestions
    ) {
      ...dokkioLabelFragment
    }
  }
  ${dokkioLabelFragment}
`;
export default mutationCreateDokkioLabel;
